import React, { useState, useEffect } from "react";
import VerticalCarousel from "./verticalCarousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
} from "@fortawesome/free-solid-svg-icons"; // Solid icons
import { Link, useParams } from "react-router-dom";
import "./style.scss";
import {
  useAddToCartMutation,
  useAddToWishlistMutation,
  useGetWishlistQuery,
  useRemoveFromWishlistMutation,
} from "../../../../services/AddToCartAPI";
import { useGetCartCountQuery } from "../../../../services/cartPageAPI";
import { useCheckVariantMutation } from "../../../../services/productDetailAPI"
// Replace or add these imports
import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import { useGetColorThemeQuery } from "../../../../services/commonAPI";

function Index({ product }) {
  const [quantity, setQuantity] = useState(1);
  const { id } = useParams();
  const [currentStock, setCurrentStock] = useState(0);
  const [currentSku, setCurrentSku] = useState("");
  const [currentPrice, setCurrentPrice] = useState("");
  const [currentAttributeId, setCurrentAttributeId] = useState(null);

  const [isWishlisted, setIsWishlisted] = useState(false);
  const [showAddToCartMessage, seShowAddToCartMessage] = useState(false);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [stockCount, setStockCount] = useState("")
  const [addToCart] = useAddToCartMutation();
  const [addToWishlist] = useAddToWishlistMutation();
  const [removeFromWishlist] = useRemoveFromWishlistMutation();
  const { data: wishlistData } = useGetWishlistQuery();
  const [checkVariant, { isLoading: checkVariantLoading }] = useCheckVariantMutation();
  const [showWishListMessage, seShowWishListMessage] = useState(false);
  const [showVariantWarning, setShowVariantWarning] = useState(false);
  const { refetch: refetchCartCountData } = useGetCartCountQuery();
const [variantCmbinationNOtExistError, setVariantCombinationNotExistMsg] = useState("") 
  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();

  useEffect(() => {
    if (product?.attributes?.[0]) {
      const defaultAttribute = product.attributes.find(
        (attr) => attr.variant_combinations.length === 0
      );
      if (defaultAttribute) {
        setCurrentStock(product?.total_stock);
        setCurrentSku(defaultAttribute.sku);
        setCurrentPrice(defaultAttribute.price || product.selling_price);
        setCurrentAttributeId(defaultAttribute.id);
      }
    } else {
      setCurrentPrice(product.selling_price);
    }
  }, [product]);


  useEffect(() => {
    if (wishlistData?.data && product) {
      const isProductWishlisted = wishlistData.data.some(
        (item) => item.product.id === product.id
      );
      setIsWishlisted(isProductWishlisted);
    }
  }, [wishlistData, product]);

  // Handle incrementing quantity
  const handleIncrement = () => {
    if (quantity < currentStock) {
      setQuantity(quantity + 1);
    }
  };

  // Handle decrementing quantity
  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  // Handle variant selection change
  // const handleVariantChange = (variantId, value) => {
  //   setSelectedVariants((prev) => ({
  //     ...prev,
  //     [variantId]: value,
  //   }));
  // };

  const handleVariantChange = (variantId, valueId) => {
    setVariantCombinationNotExistMsg("")
    setSelectedVariants((prev) => {
      const updatedVariants = { ...prev, [variantId]: valueId };

      if (Object.keys(updatedVariants).length === product.variants.length) {
        const payload = {
          product_id: parseInt(id, 10),
          variant_values: Object.values(updatedVariants),
        };

        checkVariant(payload)
          .unwrap()
          .then((res) => {
            console.log("Variant Check Successful:", res.stock);
            setStockCount(res.stock);
            setCurrentAttributeId(res.combination_id);
          })
          .catch((err) => {
            console.error("Error Checking Variant:", err);
            setVariantCombinationNotExistMsg(err?.data?.message);
          });
      }

      return updatedVariants;
    });
  };



  useEffect(() => {
    if (product?.attributes) {
      const selectedAttributes = product?.attributes?.filter((attr) => {
        return Object.entries(selectedVariants).every(([variantId, value]) => {
          const variantCombination = attr.variant_combinations.find(
            (vc) => vc.variant_id === parseInt(variantId)
          );
          return (
            variantCombination && variantCombination.variant_value_id === value
          );
        });
      });

      if (selectedAttributes.length > 0) {
        const selectedAttribute = selectedAttributes[0];
        setCurrentStock(product?.total_stock);
        setCurrentSku(selectedAttribute.sku);
        setCurrentPrice(selectedAttribute.price || product.selling_price);
        setCurrentAttributeId(selectedAttribute.id);
      } else {
        const defaultAttribute = product.attributes.find(
          (attr) => attr.variant_combinations.length === 0
        );
        if (defaultAttribute) {
          setCurrentStock(product?.total_stock);
          setCurrentSku(defaultAttribute.sku);
          setCurrentPrice(defaultAttribute.price || product.selling_price);
          setCurrentAttributeId(defaultAttribute.id);
        }
      }
    }
  }, [selectedVariants, product]);

  // Handle adding to cart
  const handleAddToCart = async () => {

    if (Object.keys(selectedVariants).length !== product.variants.length) {
      setShowVariantWarning(true);
      setTimeout(() => setShowVariantWarning(false), 5000);
      return;
    }
    else {
      const accessToken = localStorage.getItem("access_token");
      const payload = {
        product_id: product.id,
        quantity,
        product_attribute_id: currentAttributeId,
      };

      if (accessToken) {
        payload.user_id = localStorage.getItem("gridMarker");
      }

      try {
        const response = await addToCart(payload).unwrap();
        if (!accessToken && response.guest_cart_token) {
          localStorage.setItem("cartToken", response.guest_cart_token);
        }
        refetchCartCountData();
        if (response) {
          seShowAddToCartMessage(response.message);
        }
      } catch (err) {
        alert(err);
      }
    }

  };

  // Handle closing the add-to-cart message
  const handleCloseAddCartToast = () => {
    seShowAddToCartMessage(false);
  };

  // Handle adding to wishlist
  const handleAddToWishlist = async () => {
    if (isWishlisted) return;

    const accessToken = localStorage.getItem("access_token");

    console.log("wish list attribute id: ", currentAttributeId);
    const payload = {
      product_id: product.id,
      product_attribute_id: currentAttributeId,
    };

    if (accessToken) {
      payload.user_id = localStorage.getItem("gridMarker");
    }

    try {
      const response = await addToWishlist(payload).unwrap();
      if (!accessToken && response.guest_cart_token) {
        localStorage.setItem("cartToken", response.guest_cart_token);
      }
      seShowWishListMessage(response.message);
      refetchCartCountData();
      setIsWishlisted(true);
    } catch (err) {
      console.error("Failed to add product to wishlist:", err);
      alert(err);
    }
  };

  // Handle removing from wishlist
  const handleRemoveFromWishlist = async () => {
    const accessToken = localStorage.getItem("access_token");
    const payload = {
      product_id: product.id,
      product_attribute_id: currentAttributeId,
    };

    if (accessToken) {
      payload.user_id = accessToken ? localStorage.getItem("gridMarker") : null;
    }

    try {
      const response = await removeFromWishlist(payload).unwrap();
      seShowWishListMessage(response.message);
      refetchCartCountData();
      setIsWishlisted(false);
    } catch (err) {
      console.error("Failed to remove product from wishlist:", err);
      alert(err);
    }
  };

  const handleCloseWishListToast = () => {
    seShowWishListMessage(false);
  };



  if (!product) {
    return <p>No product data available.</p>;
  }

  return (
    <div className="container">
      <div className="add-to-cart">
        <div className="row">
          <div className="col-md-5 col-lg-5 col-sm-12">
            <div>
              <div className="">
                {/* <HorizontalSlider product={product} /> */}
                <VerticalCarousel product={product} />
              </div>
            </div>
          </div>
          <div className="col-md-7 col-lg-7 col-sm-12">
            {showAddToCartMessage && (
              <div className="row mb-4 justify-content-center">
                <div className="col-md-10 col-sm-12 -col-lg-10">
                  <div className="d-flex toast-message-add-to-cart">
                    <p>{showAddToCartMessage}</p>
                    <Link to="/cart-page">
                      <p className="primary-button-link"> View Cart Page</p>
                    </Link>
                    <FontAwesomeIcon
                      icon={faClose}
                      onClick={handleCloseAddCartToast}
                      className="toast-close"
                    />
                  </div>
                </div>
              </div>
            )}

            {showWishListMessage && (
              <div className="row mb-4 justify-content-center">
                <div className="col-md-12 col-sm-12 -col-lg-12">
                  <div className="d-flex toast-message-add-to-cart">
                    <p>{showWishListMessage}</p>
                    <Link to="/wishlist">
                      <p className="primary-button-link">View Wishlist</p>
                    </Link>
                    <FontAwesomeIcon
                      icon={faClose}
                      onClick={handleCloseWishListToast}
                      className="toast-close"
                    />
                  </div>
                </div>
              </div>
            )}

            {showVariantWarning && (
              <div className="row mb-4 justify-content-center">
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="d-flex toast-warning-message">
                    <p className="m-0 p-0">Please choose all product options before adding to cart.</p>
                    <FontAwesomeIcon
                      icon={faClose}
                      onClick={() => setShowVariantWarning(false)}
                      className="toast-close"
                    />
                  </div>
                </div>
              </div>
            )}


            <div>
              <h4>{product.product_name}</h4>
              <p className="product-rate p-0 m-0" style={{
                color:
                  colorthemeData?.color_themes?.[0]
                    ?.primary_color || "#a76d50",
              }}>{product?.product_price !== product?.selling_price && <span className="discount-price" style={{
                color:
                  colorthemeData?.color_themes?.[0]
                    ?.text_color_one,
              }}>{product?.product_price}</span>} ${currentPrice}</p>
              {/* <p>{product.description}</p> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: product.description,
                }}
              />

              <div className="cart-to-button-container">
                {product.variants.map((variant) => (
                  <div key={variant.variant_id} className="mb-20px">
                    <label className="variant-color-head">{variant.variant_name}</label>
                    <div className="variant-items d-flex flex-wrap gap-2">
                      {variant.values
                        .filter((value) => typeof value === "object")
                        .map((value) => (
                          <div key={value.id} className="custom-radio-wrapper">
                            <input
                              type="radio"
                              id={`variant-${variant.variant_id}-${value.id}`}
                              name={`variant-${variant.variant_id}`}
                              value={value.id}
                              checked={selectedVariants[variant.variant_id] === value.id}
                              onChange={() => handleVariantChange(variant.variant_id, value.id)}
                              className="custom-radio-input"
                            />
                            <label
                              htmlFor={`variant-${variant.variant_id}-${value.id}`}
                              className="custom-radio-box"
                              style={
                                selectedVariants[variant.variant_id] === value.id
                                  ? {
                                    backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                                    borderColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                                    fontWeight: 600,
                                    color: "#fff"
                                  }
                                  : {}
                              }
                            >
                              {value.name}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}



                <div className="cart-to-button-container">
                  {currentStock > 0 ? (
                    <>
                      <div className="quantity-selector">
                        <div className="flex items-center space-x-2">
                          <button
                            className="cart-counter-button"
                            onClick={handleDecrement}
                            disabled={quantity <= 1}
                          >
                            -
                          </button>
                          <button
                            className="cart-counter-button quantity-display"
                            disabled
                          >
                            {quantity}
                          </button>
                          <button
                            className="cart-counter-button"
                            onClick={handleIncrement}
                            disabled={quantity >= currentStock}
                          >
                            +
                          </button>
                        </div>
                        {checkVariantLoading ? (
                          <div className="spinner-border text-success" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <>
                            {stockCount === 0  || variantCmbinationNOtExistError === "Variant combination does not exist" ? (
                              <div className="out-of-stock">
                                <p className="text-red-600 font-semibold color-red m-0">Out of Stock</p>
                              </div>
                            ) : (
                              <button
                                className="primary-button"
                                onClick={handleAddToCart}
                                style={{
                                  backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                                }}
                              >
                                Add to Cart
                              </button>
                            )}
                          </>
                        )}


                      </div>

                    </>
                  ) : (
                    <div className="out-of-stock">
                      <p className="text-red-600 font-semibold color-red">Out of Stock</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="wish-to-list">
                <p
                  onClick={
                    isWishlisted
                      ? handleRemoveFromWishlist
                      : handleAddToWishlist
                  }
                  style={{
                    cursor: "pointer",
                    opacity: 1,
                  }}
                >
                  <FontAwesomeIcon
                    icon={isWishlisted ? solidHeart : regularHeart}
                    style={{
                      color: isWishlisted ? "#ff0000" : "inherit",
                      marginRight: 5,
                    }}
                  />
                  {isWishlisted ? "Remove from wishlist" : "Add to wishlist"}
                </p>
              </div>

              <div className="sku-div">
                <p>
                  <b>SKU</b>: <span>{currentSku}</span>
                </p>
                <p>
                  <b>Category</b>:{" "}
                  <span>{product.category?.category_name}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
